import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { HTTP_ENDPOINTS } from "../../consts/api";
import { http } from "../../services/HttpService";

const requestSchema = yup.object({
  clinicId: yup.number().required(),
});

export function useDeletePosConnectionMutation(options = {}) {
  return useMutation((dto) => {
    const req = requestSchema.validateSync(dto, {
      strict: true,
    });
    return http.delete(HTTP_ENDPOINTS.deletePosConnection(req.clinicId));
  }, options);
}
